// @ts-nocheck -- verbatim TAPP payroll UI compatibility boundary
import { type PropsWithChildren } from "react";
import { Card as HeroCard } from "@heroui/react";
import { clsx } from "clsx";

interface CardProps extends PropsWithChildren {
  className?: string;
  elevated?: boolean;
  padding?: "none" | "sm" | "md" | "lg";
  as?: "div" | "section" | "article";
}

const paddingClasses = {
  none: "",
  sm:   "p-3",
  md:   "p-5",
  lg:   "p-6 lg:p-8",
};

export function Card({
  children,
  className,
  elevated = false,
  padding = "md",
  as: Tag = "div",
}: CardProps) {
  return (
    <HeroCard.Root
      as={Tag}
      variant="secondary"
      className={clsx(
        "rounded-xl border border-border",
        elevated ? "bg-elevated" : "bg-surface",
        paddingClasses[padding],
        className,
      )}
    >
      {children}
    </HeroCard.Root>
  );
}

interface CardHeaderProps extends PropsWithChildren {
  className?: string;
  title?: string;
  description?: string;
  actions?: React.ReactNode;
  headingLevel?: 2 | 3;
}

export function CardHeader({
  children,
  className,
  title,
  description,
  actions,
  headingLevel = 3,
}: CardHeaderProps) {
  const Heading = `h${String(headingLevel)}` as "h2" | "h3";
  return (
    <HeroCard.Header
      className={clsx(
        "flex items-start justify-between gap-4 border-b border-border pb-4 mb-4",
        className,
      )}
    >
      {children ?? (
        <div className="min-w-0 flex-1">
          {title && (
            <Heading className="text-base font-semibold text-foreground leading-none">
              {title}
            </Heading>
          )}
          {description && (
            <p className="mt-1 text-sm text-foreground-muted">{description}</p>
          )}
        </div>
      )}
      {actions && <div className="shrink-0">{actions}</div>}
    </HeroCard.Header>
  );
}
